import React from "react";

import { Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const NfcCard = () => {
  document.title = "NFC Card | Mega ID";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Mega" breadcrumbItem="NFC Card" />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default NfcCard;
